import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import {
  ADDRESS_VALIDATION_FIELD_BROWSER_AUTOFILL,
  ADDRESS_VALIDATION_STREET_BROWSER_AUTOFILL,
} from '../constants/address-validation-browser-autofill';

const PURO_INPUT_FIELD_SELECTOR = '.puro-input__field';

/**
 * Disables browser autofill on Purolator kit text inputs.
 * Does not affect AddressComplete API suggestions driven by app code.
 */
@Directive({
  selector: 'puro-input[appDisableBrowserAutofill]',
})
export class DisableBrowserAutofillDirective implements AfterViewInit {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  /**
   * Applies the HTML autocomplete token on the kit native input after render.
   */
  ngAfterViewInit(): void {
    const mode = this.readAutofillMode();
    const nativeInput = this.elementRef.nativeElement.querySelector(PURO_INPUT_FIELD_SELECTOR);

    if (!(nativeInput instanceof HTMLInputElement)) {
      return;
    }

    nativeInput.setAttribute('autocomplete', mode);
  }

  /**
   * Reads the directive attribute value, defaulting to disabled when empty.
   */
  private readAutofillMode(): string {
    const raw = this.elementRef.nativeElement.getAttribute('appDisableBrowserAutofill');

    if (raw === ADDRESS_VALIDATION_STREET_BROWSER_AUTOFILL) {
      return ADDRESS_VALIDATION_STREET_BROWSER_AUTOFILL;
    }

    if (raw === ADDRESS_VALIDATION_FIELD_BROWSER_AUTOFILL) {
      return ADDRESS_VALIDATION_FIELD_BROWSER_AUTOFILL;
    }

    return ADDRESS_VALIDATION_FIELD_BROWSER_AUTOFILL;
  }
}
